import React from 'react';
import { NepaliInput } from 'nepali-input-react';

interface NepaliInputBoxProps {
    name: string;
    label?: string;
    value?: string|number;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    touched?: boolean;
    error?: string;
    required?: boolean;
    placeholder?: string;
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const NepaliInputBox: React.FC<NepaliInputBoxProps> = (props) => {
    const showError = props.required && props.touched && !!props.error;

    return (
        <div className='block text-[12px]'>
            {props.label && (
                <div className='flex flex-row mb-0.5'>
                    <label className="block font-medium text-slate-900 dark:text-gray-200 font-public-sans" htmlFor={props.name}>
                        {props.label}
                    </label>
                    {props.required && <span className='text-red-500 pl-1'>*</span>}
                </div>
            )}
            <NepaliInput
                name={props.name}
                value={props.value}
                onBlur={props.handleBlur}
                onChange={props.handleChange}
                placeholder={props.placeholder}
                className={`py-[3.5px] bg-transparent px-2 placeholder:text-[11.5px] !font-medium placeholder:select-none placeholder:font-light placeholder:text-gray-300 text-slate-600 dark:text-slate-300 text-[12px] rounded-sm ${
                    showError ? "!ring-[1px] !ring-red-600 shadow-sm" : "ring-[1px] ring-gray-400 dark:ring-sky-900 focus:ring-2 focus:ring-green-600"
                } font-public-sans w-full focus:outline-0`}
                required={props.required}
            />
            {showError && <p className="text-red-500 text-[10px] mt-0.5">{props.error}</p>}
        </div>
    );
};

export default NepaliInputBox;
